const accountingFR = {
    "view": {
        "table": {
            "title": "Liste de Comptabilité",
            "column": {
                "release": "Sortie",
                "period": "Période",
                "royalties": "Royalties",
                "costs": "Coûts",
                "net_revenue": "Revenu Net",
                "status": "Statut",
                "accounting_report": "Rapport de Comptabilité",
                "details": "Détails"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "button": {
                "statusCreating": "Création",
                "statusGenerating": "Génération",
                "statusGenerated": "Généré",
                "statusNotGenerated": "Non Généré",
                "open": "Ouvrir",
                "downloadPDF": "Télécharger PDF",
                "generatingPDF": "Génération PDF",
                "exportCsv": "Exporter CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filtres",
                "monthRange": "Plage de Mois",
                "release": "Sortie"
            },
            "options": {
                "allReleases": "Toutes les Sorties"
            },
            "placeholder": {
                "startingMonth": "Mois de Début",
                "endingMonth": "Mois de Fin"
            },
            "button": {
                "generate": "Générer le Rapport de Comptabilité",
                "reset": "Réinitialiser les Filtres"
            },
            "table": {
                "title": "Gains disponibles pour la comptabilité",
                "columns": {
                    "month": "Mois",
                    "year": "Année",
                    "revenue": "Revenu",
                    "status": "Statut"
                },
                "label": {
                    "status_open": "Ouvert",
                    "status_accounted": "Comptabilisé",
                    "month_january": "Janvier",
                    "month_february": "Février",
                    "month_march": "Mars",
                    "month_april": "Avril",
                    "month_may": "Mai",
                    "month_june": "Juin",
                    "month_july": "Juillet",
                    "month_august": "Août",
                    "month_september": "Septembre",
                    "month_october": "Octobre",
                    "month_november": "Novembre",
                    "month_december": "Décembre"
                }
            }
        },
        "modal": {
            "header": "Ajouter Comptabilité",
            "body": "Êtes-vous sûr de vouloir ajouter une nouvelle comptabilité pour la Sortie : {{release}}, PÉRIODE : {{startingMonth}} À {{endingMonth}} ?"
        },
        "message": {
            "success": "La comptabilité a été créée !",
            "errorSomethingWentWrong": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "errorNoEarningsAvailable": "Aucun gain disponible pour la comptabilité.",
            "errorNoReleaseSelected": "Veuillez sélectionner une sortie particulière pour la comptabilité."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Répartition de la Comptabilité",
                "column": {
                    "revenueShareHolder": "Actionnaire",
                    "revenue": "Royalty Net de l'Actionnaire",
                    "reportPdf": "Télécharger PDF",
                    "action": "Action",
                    "emailSent": "Email Envoyé"
                },
                "label": {
                    "downloadPDF": "Télécharger PDF",
                    "generatingPDF": "Génération PDF"
                },
                "button": {
                    "exportCsv": "Exporter CSV"
                },
                "modal": {
                    "confirm": {
                        "header": "Envoyer le Rapport à l'Actionnaire",
                        "body": "Êtes-vous sûr de vouloir envoyer le rapport à l'actionnaire ?",
                        "message": {
                            "success": "Rapport envoyé avec succès !"
                        },
                        "button": {
                            "cancel": "Annuler",
                            "confirm": "Confirmer"
                        }
                    }
                },
                "message": {
                    "success": "Le rapport de comptabilité a été envoyé !",
                    "errorSomethingWentWrong": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
                    "errorEmailNotPresent": "Email pour l'actionnaire non présent !",
                    "errorNoReportAvailable": "Aucun rapport disponible pour cette sortie."
                }
            }
        }
    }
};

export default accountingFR;